import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import "./style.css";

import "./registerServiceWorker";
import "vue-cal/dist/vuecal.css";
import httpService from "./services/http";

import FloatingVue from "floating-vue";

Vue.use(FloatingVue);
import "floating-vue/dist/style.css";
import VuikitIcons from "@vuikit/icons";
import "@vuikit/theme";

import SaveButtonVue from "./components/Ui/SaveButton.vue";
import config from "./config.js";

import axios from "axios";
Vue.prototype.$axios = axios;
Vue.use(VuikitIcons);
import TopSearchVue from "./components/Ui/TopSearch.vue";

Vue.filter("toCurrency", function(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  }).format(value);
});

Vue.filter("toNum2", function(value) {
  return parseFloat(value).toFixed(2);
});

Vue.filter("formatDate", function(value) {
  // Unix timestamp'i JavaScript tarihine çevir
  var date = new Date(value * 1000);

  // Tarih formatını düzenle (örneğin: 30 Ocak 2022)
  var formattedDate = date.toLocaleDateString("tr-TR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

  return formattedDate;
});

Vue.config.productionTip = true;
Vue.component("savebutton", SaveButtonVue);

import { Tabs, TabsItem } from "vuikit/lib/tabs";
import { Icon, IconLink, IconButton } from "vuikit/lib/icon";
import { Button } from "vuikit/lib/button";
import { Grid } from "vuikit/lib/grid";
import { ModalTitle, Modal, ModalClose } from "vuikit/lib/modal";
import { Navbar } from "vuikit/lib/navbar";
import {
  Nav,
  NavItemDivider,
  NavDropdown,
  NavItemHeader,
} from "vuikit/lib/nav";

import { Dropdown } from "vuikit/lib/dropdown";
import { Spinner } from "vuikit/lib/spinner";
import {
  Pagination,
  PaginationPageNext,
  PaginationPagePrev,
  PaginationPages,
} from "vuikit/lib/pagination";
import {
  Offcanvas,
  OffcanvasBar,
  OffcanvasContent,
  OffcanvasClose,
} from "vuikit/lib/offcanvas";
import EventBus from "./components/Ui/EventBus.js";
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);
Vue.component("topsearch", TopSearchVue);
Vue.component("vk-tabs", Tabs);
Vue.component("vk-icon-button", IconButton);
Vue.component("vk-icon-link", IconLink);
Vue.component("vk-spinner", Spinner);
Vue.component("vk-nav-item-divider", NavItemDivider);
Vue.component("vk-nav-dropdown", NavDropdown);
Vue.component("vk-nav-item-header", NavItemHeader);
Vue.component("vk-nav", Nav);
Vue.component("vk-grid", Grid);
Vue.component("vk-pagination", Pagination);
Vue.component("vk-pagination-pages", PaginationPages);
Vue.component("vk-pagination-page-next", PaginationPageNext);
Vue.component("vk-pagination-page-prev", PaginationPagePrev);
Vue.component("vk-dropdown", Dropdown);
Vue.component("vk-navbar", Navbar);
Vue.component("vk-icon", Icon);
Vue.component("vk-button", Button);
Vue.component("vk-tabs-item", TabsItem);
Vue.component("vk-offcanvas", Offcanvas);
Vue.component("vk-offcanvas-close", OffcanvasClose);
Vue.component("vk-offcanvas-bar", OffcanvasBar);
Vue.component("vk-offcanvas-content", OffcanvasContent);
Vue.component("vk-modal-title", ModalTitle);
Vue.component("vk-modal", Modal);
Vue.component("vk-modal-close", ModalClose);

const vm = new Vue({
  router,

  sockets: {
    fieldUpdate() {
      localStorage.getOptionList = null;
      this.getOptionList();
    },
  },

  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        localStorage.theme = "default";
        return true;
      } else {
        return false;
      }
    },
    getVal(optionKey, value) {
      if (value > 0) {
        let key = this.cache.getOptions[optionKey].find(
          (e) => e.value == value
        );

        if (key) {
          return key.label;
        }
        return "-";
      } else {
        return "-";
      }
    },
    back() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    successMessage(body) {
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "success",
        body,
        duration: 3000,
      });
    },
    errorMessage(body) {
      EventBus.$emit("bottomMessage", {
        open: true,
        title: "Hata",
        type: "error",
        duration: 5000,
        body,
      });
    },
    infoMessage(body) {
      EventBus.$emit("bottomMessage", {
        open: true,
        title: "Hatırlatma",
        type: "info",
        duration: 3000,
        body,
      });
    },
    getPerms() {
      this.$axios
        .get(config.endpoint + "/permissions")
        .then((response) => {
          this.cache.tables = this.tables = response.data.tables;
          this.cache.permissions = response.data.tables;
          this.cache.me = response.data.me;
        })
        .catch((resp) => {
          //  this.$router.push("NotFound");
        });
    },
    getOptions(id) {
      httpService.getOptions(id).then((resp) => {
        this.cache.getOptions[id] = resp.data.options;
      });
    },
    getOptionArrayValues(id) {
      let newArray = [];
      this.cache.getOptions[id].map((e) => {
        newArray.push(e.label);
      });
      return newArray;
    },
    getOptionList() {
      httpService.getOptionList().then((resp) => {
        this.cache.getOptions = resp.data;
        localStorage.getOptionList = JSON.stringify(resp.data);
      });
    },
  },

  created() {
    this.getPerms();
    if (localStorage.authToken) {
      this.getOptionList();
    }
  },
  data() {
    return {
      config: config,
      tables: [],
      cache: {
        getOptions: [],
        permissions: [],
        tables: [],
        me: [],
      },
    };
  },
  render: (h) => h(App),
}).$mount("#app");
global.vm = vm;
